import { Skeleton, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import { Ticker } from 'components/Ticker';

export interface BaseTickerProps {
  label: string;
  icon: Icon;
  value?: string;
  share?: number;
  url?: string;
  hasFailed?: boolean;
}

export const BaseTicker = ({
  label,
  icon: TickerIcon,
  value,
  share,
  url,
  hasFailed = false,
}: BaseTickerProps) => {
  const theme = useMantineTheme();
  const openInNewTab = url == null ? undefined : () => window.open(url, '_blank');

  const figure = () => {
    if (hasFailed) return <Title order={4}>—</Title>;
    if (value == null) return <Skeleton height={30} width={100} aria-busy />;

    return (
      <Stack gap={0}>
        <Title order={4}>{value}</Title>
        {share != null && (
          <Text c="dimmed" size="sm">
            {Number.isFinite(share) ? `${(share * 100).toFixed(2)} %` : '—'}
          </Text>
        )}
      </Stack>
    );
  };

  return (
    <Ticker
      title={label.toUpperCase()}
      topRight={<TickerIcon size={18} color={theme.colors.gray[6]} />}
      onClick={openInNewTab}
    >
      {figure()}
    </Ticker>
  );
};
